import type { TableCellProps} from '@chakra-ui/react'
import { Grid, Td } from '@chakra-ui/react'

export type DashboardTdProps = TableCellProps

export const TableData = ({ children, sx, ...rest }: DashboardTdProps) => {
  return (
    <Td
      verticalAlign={'middle'}
      {...rest}
      sx={{
        py: 3,
        borderBottom: '1px solid',
        borderColor: 'neutral.100',
        fontSize: 'sm',
        ...sx,
      }}
    >
      <Grid sx={{ gap: 1 }}>{children}</Grid>
    </Td>
  )
}
